import { getLinkedInAccountById } from "../../services/apiService";
import { getErrorMessage } from "../../helpers/apiError";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const unwrapAccountPayload = (response) => {
  const body = response?.data;
  if (!body) return null;
  if (body.id) return body;
  if (body.data?.id) return body.data;
  if (body.account?.id) return body.account;
  return body.data || body.account || body;
};

/** Calm, user-facing text for a failed request (see helpers/apiError). */
export const extractApiErrorMessage = (err, fallback) => getErrorMessage(err, fallback);

/**
 * Poll until iProyal proxy is READY (or FAILED / timeout).
 * Connect is blocked server-side while PENDING/PROVISIONING.
 */
export const waitForProxyReady = async (
  accountId,
  { timeoutMs = 120000, intervalMs = 2500, onStatus } = {}
) => {
  const startedAt = Date.now();
  while (Date.now() - startedAt < timeoutMs) {
    const response = await getLinkedInAccountById(accountId);
    const account = unwrapAccountPayload(response);
    const status = account?.proxyProvisioningStatus;
    if (typeof onStatus === "function") onStatus(status, account);
    if (status === "READY") return account;
    if (status === "FAILED") {
      const detail = account?.proxyProvisioningError || "Proxy provisioning failed";
      const error = new Error(detail);
      error.code = "PROXY_FAILED";
      error.account = account;
      throw error;
    }
    await sleep(intervalMs);
  }
  const error = new Error("Proxy setup timed out. Try again in a moment.");
  error.code = "PROXY_TIMEOUT";
  throw error;
};
